import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/**
 * Almikia Epic EA (TASK-111): one "tappable option" (design-system.md
 * section 8: 44px touch targets, 15px body text) shared by the activity and
 * result lists in `LogActivityForm.tsx` -- a plain `<button>` (not a radio
 * input) so the whole row is the hit target.
 */
export function PickerButton({
  selected,
  onClick,
  children,
  disabled = false,
}: {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
  /** Almikia Epic EW1 (TASK-124): a chooser option waiting on its own candidate data (e.g. the picked lead's open next-step task/project) stays visible but unclickable, rather than hidden. */
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      className={cn(
        "min-h-11 rounded-md border px-3 py-2 text-left text-[15px] disabled:opacity-50 disabled:pointer-events-none",
        selected ? "border-primary bg-primary/5" : "border-input",
      )}
    >
      {children}
    </button>
  );
}
